<template>
  <basic-master
    masterName="班長"
    insertDataPageName="addon-port-master-team-leader-insert"
    @callDelete="callDelete"
    @callSave="callSave"
    @callUpdateOrder="callUpdateOrder"
    :data="data"
    :columns="columns"
    ref="basicMaster"
  >
  </basic-master>
</template>

<script>

import BasicMaster from "../components/BasicMaster";
import { createNamespacedHelpers } from "vuex";
import { snakeCase } from "snake-case";
const { mapActions, mapState } = createNamespacedHelpers("portMaster");
export default {
  components: {
    BasicMaster
  },
  data() {
    return {
      columns: [
        {
          displayName:"名称",
          key: "name",
          searchable: true,
          inputType: "string",
        },
        {
          displayName:"略称",
          key: "short_name",
          searchable: true,
          inputType: "string",
        },
        {
          displayName:"種別",
          key: "rank",
          searchable: false,
          inputType: "select",
          selectOptions: []
        },
        {
          displayName:"備考",
          key: "description",
          searchable: false,
          inputType: "textArea",
        },
      ],
      data: [],
    }
  },
  async created() {
    this.$vs.loading()
    await this.fetchRanks(this.selectedPort.id)
    let rankIndex = this.columns.findIndex(element => element.key == "rank")
    this.columns[rankIndex].selectOptions = this.rankOptions
    this.refreshData()
    this.$vs.loading.close()
  },
  computed: {
    ...mapState({
      selectedPort: state => state.selectedPort,
      rankOptions: state => state.rankOptions,
    }),
  },
  methods: {
    ...mapActions(["fetchTeamLeaders", "updateTeamLeader", "deleteTeamLeader", "updateTeamLeaderOrders", "fetchRanks"]),
    async refreshData() {
      let res = await this.fetchTeamLeaders(this.selectedPort.id)
      this.data = res.team_leaders
    },
    async callSave(editedRowData) {
      let payload = {
        portId: this.selectedPort.id,
        id: editedRowData.id,
        body: {
          keyboard_shortcut: editedRowData.keyboard_shortcut,
          name: editedRowData.name,
          short_name: editedRowData.short_name,
          rank: Number(editedRowData.rank),
          description: editedRowData.description,
          version: editedRowData.version
        }
      }
      this.$vs.loading()
      try {
        await this.updateTeamLeader(payload)
        this.$vs.notify({
          title: "データを保存しました。",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
          position: "top-center"
        })
      } catch(error) {
        if (error.code == "422") {
          let validationErrors = error.data.validation_results.map(element => {
            let targetKey = snakeCase(element.target)
            let index = this.columns.findIndex(column => column.key == targetKey)
            let label = this.columns[index].displayName
            let message = element.message
            return {
              label: label,
              message: message
            }
          })
          this.$refs.basicMaster.openErrorPopup("エラー", null, validationErrors)
        } else {
          this.$refs.basicMaster.openErrorPopup("エラー", error.message, null)
        }
      }
      this.refreshData()
      this.$vs.loading.close()
    },
    async callDelete(id) {
      let payload = {
        portId: this.selectedPort.id,
        id: id,
      }
      this.$vs.loading()
      await this.deleteTeamLeader(payload)
      this.refreshData()
      this.$vs.loading.close()

      this.$vs.notify({
        title: "データを削除しました。",
        color: "danger",
        iconPack: "feather",
        icon: "icon-check",
        position: "top-center"
      })
    },
    async callUpdateOrder(sortOrders) {
      let payload = {
        portId: this.selectedPort.id,
        body: {
          sort_orders: sortOrders
        }
      }
      this.$vs.loading()
      await this.updateTeamLeaderOrders(payload)
      this.refreshData()
      this.$vs.loading.close()
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
